var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-breadcrumb"},_vm._l((_vm.links),function(link){return _c('span',{key:link,staticClass:"base-breadcrumb__item"},[_vm._v("\n    "+_vm._s(link)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }